import type { OperationCapability } from '../model/capabilities';
import type { BlockedReason } from '../model/operations';
import { OPERATION_PRESENTATION } from './operationPresentation';
import type { RowActionId, RowMenuEntry } from './rowTypes';
import type { LabelKey, Message } from './messages';

export type MenuPresentation<TActionId extends string = RowActionId> = {
  labelKeys: Record<TActionId, LabelKey>;
  blockedMessages: Record<BlockedReason, Message | null>;
};

export function createMenuEntries(
  capabilities: readonly OperationCapability[],
  { labelKeys, blockedMessages }: MenuPresentation
): RowMenuEntry[] {
  return capabilities.map(({ kind, blockedReason }) => {
    const { action } = OPERATION_PRESENTATION[kind];

    return {
      id: action,
      label: { key: labelKeys[action] },
      isDisabled: blockedReason !== null,
      disabledReason: blockedReason ? blockedMessages[blockedReason] : null,
    };
  });
}
